import React from "react";
import UnitsField from "src/components/capture/ReceivingWizard/Shipment/UnitsField/UnitsField";
import { BY_THE_PALLET_WAREHOUSE_BUILT } from "src/components/project/settings/utils/billingTypes";
import { useQuery } from "@apollo/client/react";
import { FETCH_PROJECT_QUERY } from "src/constants/graphql/queries";

export default function PalletsBuiltField({
  label = "Pallets Built",
  projectId,
  value,
  open,
  setOpen,
  onSubmit,
}) {
  const { data: { project = {} } = {} } = useQuery(FETCH_PROJECT_QUERY, {
    variables: { id: projectId },
    skip: !projectId,
  });

  if (project?.billingType !== BY_THE_PALLET_WAREHOUSE_BUILT) {
    return null;
  }

  const palletTypeOptions = (project?.palletTypes || [])
    .filter(pt => pt.isActive && pt.id !== "minimum_charge")
    .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
    .map(pt => pt.name);

  return (
    <UnitsField
      open={open}
      setOpen={setOpen}
      title="Total Outbound Pallets Built"
      typeLabel="Pallet Type"
      quantityLabel="# Built"
      typeKey="quantity_type"
      quantityKey="quantity_count"
      addLabel="Add Another Pallet Type"
      label={label}
      name="billingQuantities"
      value={value}
      typeOptions={palletTypeOptions}
      onSubmit={onSubmit}
    />
  );
}
